import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { InstitutionGroup } from './InstitutionGroup';
import { GROUPS_I_AM_ADMIN_OF } from './SecurityRules';
import { UserView } from './UserView';

export interface InstitutionGroupAdminRow {
  id: number;
  institution_group_id: number;
  user_id: string;
  created_at: string;
}

export const InstitutionGroupAdmin: Entity<InstitutionGroupAdminRow> = {
  id: 'InstitutionGroupAdmin',
  title: 'Institution Group Admin',
  service: 'main',
  rowLabel: (row: InstitutionGroupAdminRow) => [row.institution_group_id, row.user_id].join(' / '),
  rowLabelDynamic: (row: InstitutionGroupAdminRow) =>
    `<lookup:User:${row.user_id}> / <lookup:InstitutionGroup:${row.institution_group_id}>`,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.institution_group_admin',
  },
  security: [
    {
      role: 'admin',
      action: 'all',
      access: 'conditional',
      condition: `institution_group_id IN ${GROUPS_I_AM_ADMIN_OF}`,
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['institution_group_id', 'ASC']],
  defaultFilters: [{ fieldId: 'institution_group_id', operator: 'eq', value: '' }],
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
    },
    institution_group_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'Institution Group',
      refEntity: InstitutionGroup,
    },
    user_id: {
      seq: 15,
      label: 'User',
      type: FieldType.Reference,
      listColumn: true,
      refEntity: UserView,
    },
    created_at: {
      seq: 20,
      label: 'Created At',
      type: FieldType.Datetime,
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
    },
  },
};
